"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * This class is used for retireving supported events.
 */
var EventSupport = /*#__PURE__*/function () {
  function EventSupport() {
    _classCallCheck(this, EventSupport);
  }

  _createClass(EventSupport, null, [{
    key: "getSupportedPointerEvents",

    /**
     * Returns the supported pointer events.
     *
     * @returns {{start: string, move: string, end: string, leave: string}[]} Supported pointer events.
     */
    value: function getSupportedPointerEvents() {
      if (window.navigator.pointerEnabled) {
        return [{
          start: 'pointerdown',
          move: 'pointermove',
          end: 'pointerup',
          leave: 'pointerleave'
        }];
      } else if (window.navigator.msPointerEnabled) {
        return [{
          start: 'MSPointerDown',
          move: 'MSPointerMove',
          end: 'MSPointerUp',
          leave: 'MSPointerLeave'
        }];
      }

      return [{
        start: 'touchstart',
        move: 'touchmove',
        end: 'touchend',
        leave: 'touchleave'
      }, {
        start: 'mousedown',
        move: 'mousemove',
        end: 'mouseup',
        leave: 'mouseleave'
      }];
    }
  }]);

  return EventSupport;
}();

exports.default = EventSupport;